import { format } from '@office-start/string-formatter-utility';
import { generateGenericSlideGroup } from '../generators/generateGenericSlideGroup';
import { isNullOrWhitespace } from '../helpers/isNullOrWhitespace';
export function generateCommercialStandardUserSlideGroups(locStrings, userGreetingName, companyDisplayName) {
    if (userGreetingName === void 0) { userGreetingName = ''; }
    if (companyDisplayName === void 0) { companyDisplayName = ''; }
    var loc = locStrings.firstRunCommercialStandardUserResources;
    var slideGroupImages = [
        'cloud',
        'certificate',
        'balloons',
    ];
    var slideGroupIcons = [
        ['AddCircle', 'Folder', 'Share'],
        ['Premium', 'Cloud', 'Color'],
        ['BookOpen', 'PhoneLaptop', 'Star'],
    ];
    var commercialStandardUserSlideGroup = generateGenericSlideGroup(loc, slideGroupImages, slideGroupIcons, userGreetingName);
    if (loc.slide2TitleWithCompanyName &&
        !isNullOrWhitespace(companyDisplayName)) {
        commercialStandardUserSlideGroup[1].title = format(loc.slide2TitleWithCompanyName, companyDisplayName);
    }
    commercialStandardUserSlideGroup[0].title = locStrings
        .firstRunCommercialStandardUserResources.slide1TitleAlt;
    return [commercialStandardUserSlideGroup];
}
//# sourceMappingURL=generateCommercialStandardUserSlideGroups.js.map